import { render } from "./Servant.vue?vue&type=template&id=6da99e23&scoped=true&ts=true"
import script from "./Servant.vue?vue&type=script&lang=ts"
export * from "./Servant.vue?vue&type=script&lang=ts"

import "./Servant.vue?vue&type=style&index=0&id=6da99e23&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da99e23"]])

export default __exports__